import { render, staticRenderFns } from "./DoctorGroup.vue?vue&type=template&id=04c73092&scoped=true"
import script from "./DoctorGroup.vue?vue&type=script&lang=js"
export * from "./DoctorGroup.vue?vue&type=script&lang=js"
import style0 from "./DoctorGroup.vue?vue&type=style&index=0&id=04c73092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c73092",
  null
  
)

export default component.exports